@if (layout() === 'sidebar') {
  <button
    cuiButton
    fullWidth
    class="new-chat"
    type="button"
    variant="plain"
    (click)="newChat.emit()">
    <span class="material-symbols-outlined" aria-hidden="true">add</span>
    <span>New Chat</span>
  </button>
}
<nav class="session-list" aria-label="Chat history">
  @for (session of visibleSessions(); track session.id) {
    <button
      cuiButton
      fullWidth
      class="session"
      [class.session--active]="conversation.activeSession()?.id === session.id"
      type="button"
      variant="plain"
      [attr.aria-current]="conversation.activeSession()?.id === session.id ? 'true' : null"
      (click)="selectSession.emit(session)">
      <span class="material-symbols-outlined" aria-hidden="true">chat</span>
      <strong class="session-title">{{ session.title || 'New chat' }}</strong>
      <time class="session-date" [attr.datetime]="session.createdAt">
        {{ formatDateTime(session.createdAt) }}
      </time>
    </button>
  }
</nav>
@if (conversation.sessionHistory.loadFailed()) {
  <p class="load-error">Chats could not be loaded.</p>
}
@if (conversation.sessionHistory.hasMore() && !conversation.sessionHistory.isInitialLoad()) {
  <div class="load-more">
    <button
      cuiButton
      class="cui-text-muted"
      variant="plain"
      type="button"
      [loading]="conversation.sessionHistory.loading()"
      (click)="conversation.sessionHistory.loadMore()">
      Show more
    </button>
  </div>
}
